// Every prompt currently carrying hide:true, for /admin/hidden_prompts.
//
// This is the only place in the admin panel that shows ALL of them. The
// moderation queue can show hidden prompts, but only ones that have a report or
// live user flags - so a prompt hidden by an admin, or by a ban, was invisible
// everywhere. /admin/prompts cannot help either: it hardcodes hide:false.
//
// Deliberately NOT reusing getPrompts. That path runs through
// createPromptsQuery, which always attaches an orderBy and pagination - and
// `hide == true` combined with `orderBy bumpedAt` needs a composite index that
// does not exist, because nothing has ever queried it. A single equality plus a
// limit needs only the automatic single-field index, so this cannot fail on a
// missing index. Ordering happens client-side, over a set that is meant to be
// small.
import {
  collection,
  getDocs,
  query,
  where,
  limit
} from 'firebase/firestore';
import { GET_HIDDEN_PROMPTS, REMOVE_HIDDEN_PROMPT } from './types';
import { firestore } from '../firebase';
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from './asyncActions';
import { openSnackbar } from './snackbarActions';

// hidden prompts are a backlog to work down, not a corpus. If this ever caps
// out the page says so rather than quietly showing a slice.
export const HIDDEN_PROMPTS_LIMIT = 300;

export const getHiddenPrompts = () => async dispatch => {
  dispatch(asyncActionStart());
  try {
    const queryRef = query(
      collection(firestore, 'prompts'),
      where('hide', '==', true),
      limit(HIDDEN_PROMPTS_LIMIT)
    );
    const snapshots = await getDocs(queryRef);
    const hiddenPrompts = snapshots.docs.map(docSnapshot => ({
      ...docSnapshot.data(),
      id: docSnapshot.id
    }));
    dispatch({ type: GET_HIDDEN_PROMPTS, payload: { hiddenPrompts } });
    dispatch(asyncActionFinish());
  } catch (error) {
    console.error(error);
    dispatch(asyncActionError());
    dispatch(
      openSnackbar('ErrorSnackbar', {
        message: 'Could not load the hidden prompts.'
      })
    );
  }
};

// used after an unhide or a delete, so the row leaves without a refetch
export const removeHiddenPromptFromState = promptID => dispatch => {
  dispatch({ type: REMOVE_HIDDEN_PROMPT, payload: { promptID } });
};
